module.exports = __webpack_public_path__ + "media/src/images/logos/partners/kemenag-e0de33907b83d39b7da5f83b13091759.png";